<template>
		<div class="absolute h-16 text-center rounded-md py-2 px-2" :style="'width: 20%; left:' + (left - 10) + '%; top:' + top+'%'"
      @mouseover="showCard = true" @mouseleave="showCard = false"
     data-intro="slide-in-bottom" :data-intro-delay="100 * Math.random()">
			<img :src="player.image" alt="" class="h-12 mx-auto object-contain w-full">
			<div class="bg-rose-800 text-white text-xs mx-auto absolute bottom-2 px-1 rounded-lg">{{ player.number }}</div>
			<h4 class="text-xs font-semibold">{{ player.nickname }}</h4>
      <div class="absolute bg-white border-2 border-b-4 border-black -bottom-20 left-10 w-32 px-2 py-2 rounded-lg z-30" v-show="showCard">
        <div class="flex gap-2 items-stretch">
          <img :src="player.image" alt="" class="mx-auto object-cover w-1/3 h-full hidden">
          <div class="text-left flex flex-col justify-between">
            <h3 class="font-bold leading-none"> {{ player.name }}  </h3>
            <div class="text-xs font-semibold text-gray-500"> {{ player.position }} </div>
            <div class="text-xs font-semibold text-gray-500"> {{ player.country }} </div>
            <div class="text-xs font-semibold text-gray-500"> {{ player.dob }}</div>
            <div class="text-xs font-semibold text-gray-500 absolute bottom-2 right-2"> {{ player.number }}</div>
          </div>
        </div>
      </div>
		</div>
</template>
<script lang="ts">

import { Player } from '../types';

export default {
  name: "TeamPlayer",
  props: {
    left: {
      type: Number,
      required: true,
    },
    top: {
      type: Number,
      required: true,
    },
    player: {
      type: Object as () => Player,
      required: false,
    },
  },
  data() {
    return {
      showCard: false,
    };
  },
  mounted() {
  },
  computed: {
  },
};
</script>